export default {
  listMaterials: [],
  listCategorys: [],
  listBrands: [],
  listCatalogs: [],
  listMaterialsRequests: [],
  materialRequestsDetail: [],
  arrayMaterial: {
    catalogId: '',
    categoryMaterial: {
      opcionId: null,
      descripcion: null
    },
    brandMaterial: {
      opcionId: null,
      descripcion: null
    },
    nameMaterial: null,
    priceMaterial: null,
    skuMaterial: null,
    quantityMaterial: null,
    imageMaterial: null,
    currencyMaterial: 'CLP'
  },
  entities: [],
  fieldMaterial: [
    { key: 'idMaterial', label: '' },
    { key: 'skuMaterial', label: 'SKU' },
    { key: 'nameMaterial', label: 'Nombre Material' },
    { key: 'brandMaterial', label: 'Marca' },
    { key: 'categoryMaterial', label: 'Categoría' },
    { key: 'priceMaterial', label: 'Precio Unitario' },
    { key: 'currencyMaterial', label: 'Moneda' },
    { key: 'actions', label: '' }
  ],
  fieldMaterialsRequest: [
    { key: 'numero', label: 'Folio' },
    { key: 'request', label: 'Nombre Solicitud' },
    { key: 'name', label: 'Solicitante' },
    { key: 'dateRequest', label: 'Fecha Solicitud' },
    { key: 'precioSolicitudTotal', label: 'Monto' },
    { key: 'statusCode', label: 'Estado' },
    { key: 'action', label: '' }
  ],
  fieldMaterialsRequestDetail: [
    { key: 'SKU', label: 'SKU' },
    { key: 'nombre', label: 'Material' },
    { key: 'marca', label: 'Marca' },
    { key: 'categoria', label: 'Categoría' },
    { key: 'cantidadSolicitar', label: 'Cantidad' },
    { key: 'precio', label: 'Precio' },
    { key: 'totalSolicitar', label: 'Precio Total' }
  ],
  showModal: false,
  loading: false,
  pagination: {
    items: 0,
    pages: 0
  },
  optionUsers: [],
  services: [],
};
